module.exports = __webpack_public_path__ + "img/gear-A-cogs_64x64.a8e937c4.png";